import { Routes } from '@angular/router';
import { MyAccountComponent } from './my-account/my-account.component';
import { NotFoundComponent } from './security/not-found/not-found.component';
import { ProfilesComponent } from './my-account/profiles/profiles.component';
import { CustomerServiceComponent } from './my-account/customer-service/customer-service.component';
import { NotificationComponent } from './my-account/notification/notification.component';
import { PreferencesComponent } from './my-account/preferences/preferences.component';
import { FaqComponent } from './my-account/faq/faq.component';
import { ProfileProviderPFComponent } from './my-account/profiles/profile-provider-pf/profile-provider-pf.component';
import { ShoppingCardComponent } from './my-account/shopping-card/shopping-card.component';
import { ProfileProviderPJComponent } from './my-account/profiles/profile-provider-pj/profile-provider-pj.component';
import { UserComponent } from './my-account/user/user.component';
import { DashboardProviderPFComponent } from './dashboard/dashboard-provider-pf/dashboard-provider-pf.component';
import { DashboardProviderPJComponent } from './dashboard/dashboard-provider-pj/dashboard-provider-pj.component';
import { UserPreferencesCacheResolver } from './shared/services/user-preferences-cache.resolver';
import { AdminCustomerServiceComponent } from './dashboard/dashboard-admin/admin-customer-service/admin-customer-service.component';
import { ServiceOfferingProviderPFComponent } from './dashboard/dashboard-provider-pf/service-offering-provider-pf/service-offering-provider-pf.component';
import { ProviderPFComponent } from './dashboard/dashboard-provider-pf/provider-pf.component';
import { ServiceOfferingProviderPFFormComponent } from './dashboard/dashboard-provider-pf/service-offering-provider-pf-form/service-offering-provider-pf-form.component';
import { AuthGuard } from './security/auth.guard';
import { CpfRequiredGuard } from './security/cpf-required.guard';
import { NotAutorizationComponent } from './security/not-autorization/not-autorization.component';
import { AuthRedirectGuard } from './security/auth_redirect.guard';
import { WelcomeComponent } from './layout/welcome/welcome.component';
import { ServerOffLineComponent } from './security/serverOffLine/serverOffLine.component';
import { CoreComponent } from './layout/core/core.component';
import { ShareDocumentsProfilePFComponent } from './dashboard/dashboard-provider-pf/share-documents-profile-pf/share-documents-profile-pf.component';
import { ProviderPJComponent } from './dashboard/dashboard-provider-pj/provider-pj.component';
import { ShareDocumentsProfilePJComponent } from './dashboard/dashboard-provider-pj/share-documents-profile-pj/share-documents-profile-pj.component';
import { HomeComponent } from './layout/home/home.component';
import { AdminComponent } from './dashboard/dashboard-admin/admin.component';
import { CertificateInfoComponent } from './dashboard/dashboard-admin/certification/certificate-info.component';
import { AdminOverviewComponent } from './dashboard/dashboard-admin/admin-overview/admin-overview.component';
import { ResourceOfferingProviderPJFormComponent } from './dashboard/dashboard-provider-pj/resource-offering-provider-pj-form/resource-offering-provider-pj-form.component';
import { ResourceOfferingProviderPJComponent } from './dashboard/dashboard-provider-pj/resource-offering-provider-pj/resource-offering-provider-pj.component';
import { ServiceOfferingProviderPJComponent } from './dashboard/dashboard-provider-pj/service-offering-provider-pj/service-offering-provider-pj.component';
import { ServiceOfferingProviderPJFormComponent } from './dashboard/dashboard-provider-pj/service-offering-provider-pj-form/service-offering-provider-pj-form.component';
import { ServiceDemandComponent } from './dashboard/dashboard-provider-pj/service-demand/service-demand.component';
import { ServiceDemandFormComponent } from './dashboard/dashboard-provider-pj/service-demand-form/service-demand-form.component';
import { ResourceDemandComponent } from './dashboard/dashboard-provider-pj/resource-demand/resource-demand.component';
import { ResourceDemandFormComponent } from './dashboard/dashboard-provider-pj/resource-demand-form/resource-demand-form.component';
import { AdminFaqComponent } from './dashboard/dashboard-admin/admin-faq/admin-faq.component';
import { AdminDocumentShareComponent } from './dashboard/dashboard-admin/admin-document-share/admin-document-share.component';
import { AdminProfessionComponent } from './dashboard/dashboard-admin/admin-profession/admin-profession.component';
import { AdminNotificationComponent } from './dashboard/dashboard-admin/admin-notification/admin-notification.component';
import { AdminProductsComponent } from './dashboard/dashboard-admin/admin-products/admin-products.component';
import { AdminPlanComponent } from './dashboard/dashboard-admin/admin-plan/admin-plan.component';
import { AdminPaymentComponent } from './dashboard/dashboard-admin/admin-payment/admin-payment.component';
import { UserPlansComponent } from './my-account/plan-payment/user-plans/user-plans.component';
import { UserPaymentsComponent } from './my-account/plan-payment/user-payments/user-payments.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { PlanStatusCacheResolver } from './shared/services/plan-status-cache.resolver';
import { NegotiationPainelComponent } from './shared/negotiation-painel/negotiation-panel.component';
import { AdminProductPackageComponent } from './dashboard/dashboard-admin/admin-product-package/admin-product-package.component';
import { SelecNewProfileComponent } from './shared/selec-new-profile/selec-new-profile.component';
import { ThemeTestComponent } from './theme-test/theme-test.component';
import { PlanPaymentDashboardComponent } from './my-account/plan-payment/plan-payment-container/plan-payment-dashboard.component';
export const routes: Routes = [
  {
    path: 'theme-test',
    component: ThemeTestComponent,
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
    canActivate: [AuthRedirectGuard],
  },
  {
    path: '',
    component: CoreComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'my-account',
        component: MyAccountComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'user',
            component: UserComponent,
            resolve: { userPreferences: UserPreferencesCacheResolver },
          },
          {
            path: 'profiles',
            component: ProfilesComponent,
            canActivate: [AuthGuard, CpfRequiredGuard],
            children: [
              {
                path: 'select-new-profile',
                component: SelecNewProfileComponent,
                canActivate: [AuthGuard],
              },
              {
                path: 'profileProviderPFForm/:id',
                component: ProfileProviderPFComponent,
              },
              {
                path: 'profileProviderPFForm',
                component: ProfileProviderPFComponent,
              },
              {
                path: 'profileProviderPJForm/:id',
                component: ProfileProviderPJComponent,
              },
              {
                path: 'profileProviderPJForm',
                component: ProfileProviderPJComponent,
              },
              {
                path: 'profileProviderPJForm/:id',
                component: ProfileProviderPJComponent,
              },
              {
                path: 'profileProviderPJForm',
                component: ProfileProviderPJComponent,
              },
            ],
          },
          {
            path: 'notification',
            canActivate: [AuthGuard, CpfRequiredGuard],
            component: NotificationComponent,
          },
          {
            path: 'prefereces',
            canActivate: [AuthGuard, CpfRequiredGuard],
            component: PreferencesComponent,
          },
          // {
          //   path: 'my-plans',
          //   canActivate: [AuthGuard, CpfRequiredGuard],
          //   component: UserPlansComponent,
          // },
          // {
          //   path: 'my-payments',
          //   canActivate: [AuthGuard, CpfRequiredGuard],
          //   component: UserPaymentsComponent,
          // },
          {
            path: 'plans-payments',
            canActivate: [AuthGuard, CpfRequiredGuard],
            component: PlanPaymentDashboardComponent
          }
        ],
      },

      {
        path: 'providerPF/:id',
        component: ProviderPFComponent,
        canActivate: [AuthGuard, CpfRequiredGuard],
        children: [
          {
            path: '',
            component: DashboardProviderPFComponent,
          },
          {
            path: 'shareDocuments',
            component: ShareDocumentsProfilePFComponent,
          },
          {
            path: 'negotiationPainel/:participantCpfCnpj',
            component: NegotiationPainelComponent,
          },
          {
            path: 'serviceOffering',
            component: ServiceOfferingProviderPFComponent,
          },
          {
            path: 'serviceOffering/serviceOfferingForm',
            component: ServiceOfferingProviderPFFormComponent,
          },
          {
            path: 'serviceOffering/serviceOfferingForm/:id',
            component: ServiceOfferingProviderPFFormComponent,
          },
        ],
      },
      {
        path: 'providerPJ/:id',
        component: ProviderPJComponent,
        canActivate: [AuthGuard, CpfRequiredGuard],
        children: [
          {
            path: '',
            component: DashboardProviderPJComponent,
          },
          {
            path: 'shareDocuments',
            component: ShareDocumentsProfilePJComponent,
          },
          {
            path: 'negotiationPainel/:participantCpfCnpj',
            component: NegotiationPainelComponent,
          },
          {
            path: 'serviceOffering',
            component: ServiceOfferingProviderPJComponent,
          },
          {
            path: 'serviceOffering/serviceOfferingForm',
            component: ServiceOfferingProviderPJFormComponent,
          },
          {
            path: 'serviceOffering/serviceOfferingForm/:id',
            component: ServiceOfferingProviderPJFormComponent,
          },
          {
            path: 'resourceOffering',
            component: ResourceOfferingProviderPJComponent,
          },
          {
            path: 'resourceOffering/resourceOfferingForm',
            component: ResourceOfferingProviderPJFormComponent,
          },
          {
            path: 'resourceOffering/resourceOfferingForm/:id',
            component: ResourceOfferingProviderPJFormComponent,
          },

          {
            path: 'serviceDemand',
            component: ServiceDemandComponent,
          },
          {
            path: 'serviceDemand/serviceDemandForm',
            component: ServiceDemandFormComponent,
          },
          {
            path: 'serviceDemand/serviceDemandForm/:id',
            component: ServiceDemandFormComponent,
          },
          {
            path: 'resourceDemand',
            component: ResourceDemandComponent,
          },
          {
            path: 'resourceDemand/resourceDemandForm',
            component: ResourceDemandFormComponent,
          },
          {
            path: 'resourceDemand/resourceDemandForm/:id',
            component: ResourceDemandFormComponent,
          },


        ],
      },
      {
        path: 'search',
        component: AdvancedSearchComponent,
        canActivate: [AuthGuard, CpfRequiredGuard],
        resolve: { planStatuses: PlanStatusCacheResolver },
      },
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AuthGuard, CpfRequiredGuard],
        data: {
          roles: ['ADMIN', 'SUPPORT'],
          title: 'Administrador',
        },
        children: [
          {
            path: '',
            component: AdminCustomerServiceComponent,
          },
          {
            path: 'access-overview',
            component: AdminOverviewComponent,
          },
          {
            path: 'certificate-info/:profile/:id/:csId',
            component: CertificateInfoComponent,
          },
          {
            path: 'admin-faq',
            component: AdminFaqComponent,
          },
          {
            path: 'admin-document-share',
            component: AdminDocumentShareComponent,
          },
          {
            path: 'admin-profession',
            component: AdminProfessionComponent,
          },
          {
            path: 'admin-notification',
            component: AdminNotificationComponent,
          },
          {
            path: 'admin-products',
            component: AdminProductsComponent,
          },
          {
            path: 'admin-products-package',
            component: AdminProductPackageComponent,
          },
          {
            path: 'admin-plan',
            component: AdminPlanComponent,
          },
          {
            path: 'admin-payment',
            component: AdminPaymentComponent,
          },
        ],
      },
      {
        path: 'faq',
        component: FaqComponent,
      },
      {
        path: 'customer-service',
        canActivate: [AuthGuard, CpfRequiredGuard],
        component: CustomerServiceComponent,
      },
      {
        path: 'shopping',
        component: ShoppingCardComponent,
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'unauthorized',
        component: NotAutorizationComponent,
      },
      {
        path: 'serverOffLine',
        component: ServerOffLineComponent,
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
